export const HandleAudio = () => {

    const audioEls =  document.querySelectorAll('audio');

    audioEls?.forEach((elem) =>{
        audioEls.forEach((audio) => {
            audio.addEventListener('play', () => {
                audio.parentElement.classList.add('is-playing');
                audioEls.forEach((otherAudio) => {
                    if (otherAudio !== audio) {
                        otherAudio.pause();
                        otherAudio.parentElement.classList.remove('is-playing');
                    }
                });
            });

            audio.addEventListener('pause', () => {
                audio.parentElement.classList.remove('is-playing');
            });

            audio.addEventListener('ended', () => {
                audio.parentElement.classList.remove('is-playing');
            });
        });
    });


}